export default __webpack_public_path__ + "static/media/mockCommon-300.5293a575.png";